import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "course-module"
};
var _hoisted_2 = {
  class: "top-nav"
};
var _hoisted_3 = {
  class: "course-content"
};
var _hoisted_4 = {
  class: "menu"
};
var _hoisted_5 = {
  class: "course-list"
};
var _hoisted_6 = {
  key: 0,
  class: "list-loading"
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "left"
};
var _hoisted_10 = {
  class: "top"
};
var _hoisted_11 = {
  key: 0,
  class: "red"
};
var _hoisted_12 = {
  class: "bottom"
};
var _hoisted_13 = {
  style: {
    "margin-right": "10px"
  }
};
var _hoisted_14 = {
  class: "right"
};
var _hoisted_15 = {
  key: 0,
  class: "time"
};
var _hoisted_16 = {
  key: 2,
  class: "list-empty"
};
import { ref } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import FilePreviewDialog from 'hxhy-file-preview';
import { sendTracker } from 'point-track';
import SubjectTab from '../Common/SubjectTab.vue';
import { studentCourseList, readCourse, getAppAlias, readResource } from '@/api/home';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var loading = ref(false);
    var courseList = ref([]);
    var _ref = getStore({
        name: 'accessInfo'
      }) || {},
      access_token = _ref.access_token,
      username = _ref.username;
    var resourceVisible = ref(false);
    var currentItem = ref(null);
    var subjectItem = ref(null);
    var handleChangeSubject = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(subject) {
        var _yield$studentCourseL, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              console.log(subject, 11);
              _context.p = 1;
              subjectItem.value = subject;
              loading.value = true;
              _context.n = 2;
              return studentCourseList({
                subjectDictItemCode: subject === null || subject === void 0 ? void 0 : subject.code
              });
            case 2:
              _yield$studentCourseL = _context.v;
              data = _yield$studentCourseL.data;
              courseList.value = (data === null || data === void 0 ? void 0 : data.data) || [];
              console.log(data);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log(_t);
            case 4:
              _context.p = 4;
              loading.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function handleChangeSubject(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    // 标签类型
    var tagType = function tagType(item) {
      var className = '';
      switch (item) {
        case 0:
          className = 'course-tag';
          break;
        case 1:
          className = 'resource-tag';
          break;
        case 2:
          className = 'exercise-tag';
          break;
        case 3:
          className = 'english-tag';
          break;
        default:
          break;
      }
      return className;
    };
    var tagTypeName = function tagTypeName(item) {
      var typeName = '';
      switch (item) {
        case 0:
          typeName = '学程';
          break;
        case 1:
          typeName = '素材';
          break;
        case 2:
          typeName = '习练';
          break;
        case 3:
          typeName = '口语';
          break;
        default:
          break;
      }
      return typeName;
    };
    var extractEnvFromUrl = function extractEnvFromUrl(url) {
      var match = url.match(/https?:\/\/(\w*)web\.zhixuehuijiao\.cn/);
      return match ? match[1] || '' : '';
    };
    var getCourseUrl = function getCourseUrl() {
      var env = extractEnvFromUrl(window.location.origin);
      return "https://".concat(env ? env : 'edu-', "course.zhixuehuijiao.cn");
    };
    var handleClickCourse = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return readCourse(item.resId, item.version);
            case 1:
              item.isRead = true;
              sendPointEvent('view_course_001');
              if (item.version === 1) {
                window.open("".concat(getCourseUrl(), "/courseDetail?id=").concat(item.resId, "&source=").concat(item.version, "&token=").concat(access_token));
              } else {
                window.open("".concat(getCourseUrl(), "/study?courseId=").concat(item.resId, "&deptId=").concat(item.deptId, "&groupId=").concat(item.groupId, "&source=").concat(item.version, "&token=").concat(access_token, "&scene=\u5B66\u7A0B"));
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function handleClickCourse(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    var handleClickExercise = function handleClickExercise(item) {
      sendPointEvent('view_paper_001');
      window.open("".concat(window.location.origin, "/learnCentre?learnCentre=/sub-learn-centre-svc/answer/").concat(item.resId, "/").concat(item.groupId));
    };
    var handleClickMore = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _subjectItem$value, _yield$getAppAlias, data, _ref5, userIsGod, result, memberStatus, userStatus, hasAuth, url, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return getAppAlias('learnCentre');
            case 1:
              _yield$getAppAlias = _context3.v;
              data = _yield$getAppAlias.data;
              _ref5 = (data === null || data === void 0 ? void 0 : data.data) || {}, userIsGod = _ref5.userIsGod, result = _ref5.result, memberStatus = _ref5.memberStatus, userStatus = _ref5.userStatus;
              hasAuth = userIsGod || result === 'access' && memberStatus === 0 && userStatus === 0;
              if (hasAuth) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, MessagePlugin.warning('暂无权限'));
            case 2:
              url = "".concat(window.location.origin, "/learnCentre?learnCentre=/sub-learn-centre-svc/mine&subject=").concat((_subjectItem$value = subjectItem.value) === null || _subjectItem$value === void 0 ? void 0 : _subjectItem$value.code, "&token=").concat(access_token);
              window.open(url);
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.log(_t3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 3]]);
      }));
      return function handleClickMore() {
        return _ref4.apply(this, arguments);
      };
    }();
    var handleClickItem = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(item) {
        var _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _t4 = item.type;
              _context4.n = _t4 === 0 ? 1 : _t4 === 1 ? 2 : _t4 === 2 ? 4 : _t4 === 3 ? 5 : 6;
              break;
            case 1:
              handleClickCourse(item);
              return _context4.a(3, 7);
            case 2:
              currentItem.value = item;
              resourceVisible.value = true;
              _context4.n = 3;
              return readResource(item.resId);
            case 3:
              item.isRead = true;
              sendPointEvent('view_resource_001');
              return _context4.a(3, 7);
            case 4:
              handleClickExercise(item);
              item.isRead = true;
              return _context4.a(3, 7);
            case 5:
              MessagePlugin.warning('web端暂不支持口语评测，请至学生平板端进行口语练习');
              return _context4.a(3, 7);
            case 6:
              return _context4.a(3, 7);
            case 7:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function handleClickItem(_x3) {
        return _ref6.apply(this, arguments);
      };
    }();
    var userInfo = getStore({
      name: 'userInfo'
    });
    var sendPointEvent = function sendPointEvent(code) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      sendTracker.track([{
        userId: userInfo.id,
        taskCode: code,
        businessData: data
      }]);
    };
    return function (_ctx, _cache) {
      var _courseList$value, _courseList$value2, _currentItem$value, _currentItem$value2, _subjectItem$value2, _subjectItem$value3;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_Loading = _resolveComponent("Loading");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(SubjectTab, {
        "show-all": "",
        onChange: handleChangeSubject
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, [_createVNode(_component_svg_icon, {
        name: "zzxx",
        size: "18"
      }), _cache[1] || (_cache[1] = _createTextVNode("自主学习", -1))]), _createElementVNode("span", {
        onClick: handleClickMore
      }, [_cache[2] || (_cache[2] = _createTextVNode("查看更多 ", -1)), _createVNode(_component_svg_icon, {
        style: {
          "margin-left": "5px"
        },
        name: "home-more",
        size: "13"
      })])]), _createElementVNode("div", _hoisted_5, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_Loading), _cache[3] || (_cache[3] = _createElementVNode("span", null, "加载中...", -1))])) : _createCommentVNode("", true), !loading.value && (_courseList$value = courseList.value) !== null && _courseList$value !== void 0 && _courseList$value.length ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.resId,
          class: "course-item",
          onClick: function onClick($event) {
            return handleClickItem(item);
          }
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", {
          class: _normalizeClass(["tag", tagType(item.type)])
        }, _toDisplayString(tagTypeName(item.type)), 3), _createElementVNode("h2", null, [_createTextVNode(_toDisplayString(item.title) + " ", 1), !item.isRead ? (_openBlock(), _createElementBlock("i", _hoisted_11)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(item.teacherName), 1), _createElementVNode("span", null, [_createTextVNode(_toDisplayString(item.startTime) + " ", 1), item.endTime ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode("-" + _toDisplayString(item.endTime), 1)], 64)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_14, [item.type !== 1 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "剩余：" + _toDisplayString(item.duration), 1)) : _createCommentVNode("", true), item.type === 1 ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["read", item.isRead ? 'active' : ''])
        }, _toDisplayString(item.isRead ? '已查看' : '未查看'), 3)) : _createCommentVNode("", true)])], 8, _hoisted_8);
      }), 128))])) : _createCommentVNode("", true), !loading.value && !((_courseList$value2 = courseList.value) !== null && _courseList$value2 !== void 0 && _courseList$value2.length) ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)])]), _createVNode(_unref(FilePreviewDialog), {
        modelValue: resourceVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return resourceVisible.value = $event;
        }),
        "source-id": (_currentItem$value = currentItem.value) === null || _currentItem$value === void 0 ? void 0 : _currentItem$value.resId,
        "source-name": (_currentItem$value2 = currentItem.value) === null || _currentItem$value2 === void 0 ? void 0 : _currentItem$value2.title,
        token: _unref(access_token),
        showDownload: true,
        "subject-id": (_subjectItem$value2 = subjectItem.value) === null || _subjectItem$value2 === void 0 ? void 0 : _subjectItem$value2.id,
        "subject-name": (_subjectItem$value3 = subjectItem.value) === null || _subjectItem$value3 === void 0 ? void 0 : _subjectItem$value3.displayName
      }, null, 8, ["modelValue", "source-id", "source-name", "token", "subject-id", "subject-name"])]);
    };
  }
};